export function useDateFormatted(dateUnformatted: string) {
  const dateFormatted = ref<string | null>(null);
  const dateStringToDateFormat = new Date(dateUnformatted);

  const date = dateStringToDateFormat
    .toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
    .replace(/ /g, " ");

  dateFormatted.value = date.toLowerCase();

  return { dateFormatted };
}
